module.exports = __webpack_public_path__ + "img/training_room-right_bottom.a01bb542.jpg";